import { CheckCircle2, XCircle } from "lucide-react";

export function ProblemSolution() {
  return (
    <section className="py-20 bg-slate-900 text-white overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-[#FD5750] font-bold tracking-wider text-sm uppercase mb-2 block">
              The Reality
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Why most digital projects <span className="text-[#FD5750]">fail to deliver</span>
            </h2>
            <p className="text-slate-300 text-lg mb-8 leading-relaxed">
              Many businesses fall into the trap of choosing the <b>cheapest service provider</b>. The result? A product that looks okay but fails to solve real business problems, has poor user experience, or isn't scalable.
            </p>
            
            <div className="space-y-6">
              <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700">
                <h3 className="text-xl font-semibold mb-4 flex items-center gap-3">
                  <XCircle className="text-red-400" />
                  <span>The Typical Agency Approach</span>
                </h3>
                <ul className="space-y-3 text-slate-400">
                  <li className="flex gap-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2"></span>
                    <span>"Yes-man" culture: Building exactly what you asked for, even if it's wrong.</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2"></span>
                    <span>Focus on aesthetics over functionality and business logic.</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2"></span>
                    <span>Poor communication and missed deadlines.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="relative">
             <div className="absolute -inset-4 bg-[#FD5750]/20 rounded-2xl blur-xl"></div>
             <div className="bg-white text-slate-900 p-8 md:p-10 rounded-2xl relative shadow-2xl">
                <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
                  <CheckCircle2 className="text-green-500 w-8 h-8" />
                  <span>The Intelisine Way</span>
                </h3>
                <p className="text-slate-600 mb-8">
                  We don't just write code. We sit with you to understand your business model, your users, and your long-term goals. We act as your technical co-founder.
                </p>
                
                <ul className="space-y-4">
                  {[
                    "Strategic consulting before a single line of code is written.",
                    "User-centric design based on psychological models.",
                    "Scalable architecture that grows with your business.",
                    "Transparent communication and agile delivery."
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <CheckCircle2 className="w-4 h-4 text-green-600" />
                      </div>
                      <span className="font-medium text-slate-700">{item}</span>
                    </li>
                  ))}
                </ul>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
}
